<template>
  <div class="container-fluid h-100">

    <ul class="nav nav-tabs justify-content-center">
      <li class="nav-item">
        <a class="nav-link list" @click="changeView(1)">Listar puntos de venta</a>
      </li>
      <li class="nav-item">
        <a class="nav-link created" @click="changeView(2)">Crear punto de venta</a>
      </li>
    </ul>

    <!-- Listar puntos de venta -->
    <div v-if="list" class="section_list">
      <div class="row mt-2 pt-3">
        <div style="color:black;" class="col-12 col-md-3 mt-2">
          <span><strong>Filtrar por distribuidor:</strong></span>
        </div>
        <div class="col-12 col-md-4">
          <select
            class="form-control"
            name="state"
            id="state"
            v-model="dist_id"
            v-on:change="getByDist(dist_id)"
          >
            <option disabled selected value="null">Seleccione el distribuidor</option>
            <option v-for="dist in listDist" :key="dist.id" :value="dist.id">
              {{ dist.name }}
            </option>
          </select>
        </div>
      </div>
  
      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width:4em; height:4rem; margin:20px;"
            role="status"
          ></div>
        </div>
      </template>
  
      <div class="row mt-4">
        <div class="col-12">
          <div class="table-responsive">
  
            <div class="info">
              <div class="title_info">
                <span>EQUIVALENCIA DE PUNTOS:</span>
              </div>
              <div class="desc_info">
                <strong>Nota: </strong><span><strong>3</strong> galones equivalen a <strong>1</strong> caja</span><br>
                <strong>Mineral: </strong><span><strong>1</strong> punto por galón (<strong>3</strong> puntos por caja)</span><br>
                <strong>Semi Synthetic: </strong><span><strong>2</strong> puntos por galón (<strong>6</strong> puntos por caja)</span><br>
                <strong>Full Synthetic: </strong><span><strong>2</strong> puntos por galón (<strong>6</strong> puntos por caja)</span><br>
              </div>
            </div>
  
            <table class="table table-striped">
              <caption class="visually-hidden">Equivalencia de Puntos</caption>
              <thead class="table-dark">
                <tr>
                  <th scope="col" style="text-align: left">Nit</th>
                  <th scope="col" style="text-align: left">Nombre del establecimiento</th>
                  <th scope="col" style="text-align: left">Departamento</th>
                  <th scope="col" style="text-align: left">Ciudad</th>
                  <th scope="col" style="text-align: left">Dirección</th>
                  <th scope="col" style="text-align: left">Email</th>
                  <th scope="col" style="text-align: left">Número telefónico</th>
                  <th scope="col" style="text-align: left">Puntos</th>
                  <th scope="col" style="text-align: left">Acción 1</th>
                  <th scope="col" style="text-align: left">Acción 2</th>
                  <th scope="col" style="text-align: left">Acción 3</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in listPOS" :key="'d' + `item-${i}`">
                  <td style="text-align: left">
                    {{ item.document_number }}
                  </td>
                  <td style="text-align: left">
                    {{ item.name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.state_name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.city_name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.address }}
                  </td>
                  <td style="text-align: left">
                    {{ item.email }}
                  </td>
                  <td style="text-align: left">
                    {{ item.phone }}
                  </td>
                  <td style="text-align: center">
                    <strong>{{ item.amount }}</strong>
                  </td>
                  <td style="text-align: left">
                    <div class="btn-group" role="group">
                      <div class="btn-group" role="group">
                        <button
                          class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                          title="Asignar puntos"
                          @click="assignModal(item)"
                        >
                          <span class="fa-solid fa-gift"></span>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td class="action_1" @click="editPOS(item)"><strong>Editar</strong></td>
                  <td class="action_2" @click="deletePOS(item)"><strong>Eliminar</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Crear puntos de venta -->
    <div v-if="created" class="section_create">
      <form>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="text_label">Nit *</label>
            <input 
              v-model="formCreate.nit" 
              type="text" 
              class="form-control" 
              placeholder="Escriba aquí el Nit"
            >
            <span v-if="errorsCreate.nit" class="errors">{{ errorsCreate.nit }}</span>
          </div>
          <div class="form-group col-md-6">
            <label class="text_label">Nombre del establecimiento *</label>
            <input 
              v-model="formCreate.storeName" 
              type="text" 
              class="form-control" 
              placeholder="Escriba aquí el Nombre del establecimiento"
            >
            <span v-if="errorsCreate.storeName" class="errors">{{ errorsCreate.storeName }}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="text_label">Departamento *</label>
            <select 
              v-model="formCreate.state" 
              @change="getCities(formCreate.state)" 
              class="form-control"
            >
              <option selected value="null">Seleccione el Departamento</option>
              <option 
                v-for="state in listStates" 
                :key="state.id" 
                :value="state.id"
              >
                {{ state.name }}
              </option>
            </select>
            <span v-if="errorsCreate.state" class="errors">{{ errorsCreate.state }}</span>
          </div>
          <div class="form-group col-md-6">
            <label class="text_label">Ciudad *</label>
            <select 
              v-model="formCreate.city" 
              :disabled="showCities" 
              class="form-control"
            >
              <option disabled selected value="null">Seleccione la Ciudad</option>
              <option 
                v-for="city in listCities" 
                :key="city.id" 
                :value="city.id"
              >
                {{ city.name }}
              </option>
            </select>
            <span v-if="errorsCreate.city" class="errors">{{ errorsCreate.city }}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="text_label">Dirección *</label>
            <input 
              v-model="formCreate.address" 
              type="text" 
              class="form-control" 
              placeholder="Escriba aquí la Dirección"
            >
            <span v-if="errorsCreate.address" class="errors">{{ errorsCreate.address }}</span>
          </div>
          <div class="form-group col-md-6">
            <label class="text_label">Email *</label>
            <input 
              v-model="formCreate.email" 
              type="email" 
              class="form-control" 
              placeholder="Escriba aquí el Email"
            >
            <span v-if="errorsCreate.email" class="errors">{{ errorsCreate.email }}</span>
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="form-group col-md-6">
            <label class="text_label">Número telefónico *</label>
            <input 
              v-model="formCreate.phone" 
              type="number" 
              class="form-control" 
              placeholder="Escriba aquí el Número telefónico"
            >
            <span v-if="errorsCreate.phone" class="errors">{{ errorsCreate.phone }}</span>
          </div>
          <div class="form-group col-md-6">
            <label class="text_label">Distribuidor *</label>
            <select 
              v-model="formCreate.distributor" 
              class="form-control"
            >
              <option disabled selected value="null">Seleccione el Distribuidor</option>
              <option 
                v-for="dist in listDist" 
                :key="dist.id" 
                :value="dist.id"
              >
                {{ dist.name }}
              </option>
            </select>
            <span v-if="errorsCreate.distributor" class="errors">{{ errorsCreate.distributor }}</span>
          </div>
        </div>
      </form>
      <div class="row justify-content-center section_btn">
        <button 
          @click="createPOS()" 
          class="btn btn-danger"
        >
          <span v-if="loading.create">
            Creando...
          </span>
          <span v-else>Crear</span>
        </button>
      </div>
    </div>

    <!-- Modal para editar los puntos de venta -->
    <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Editar Punto de Venta</h5>
            <button 
              type="button" 
              class="close" 
              data-dismiss="modal" 
              aria-label="Close"
              @click="closeModal(2)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="text_label">Nit *</label>
                <input 
                  v-model="editForm.nit" 
                  type="text" 
                  class="form-control" 
                  placeholder="Escriba aquí el Nit"
                  :disabled="disabled"
                >
                <span v-if="editError.nit" class="errors">{{ editError.nit }}</span>
              </div>
              <div class="form-group col-md-6">
                <label class="text_label">Nombre del establecimiento *</label>
                <input 
                  v-model="editForm.storeName" 
                  type="text" 
                  class="form-control" 
                  placeholder="Escriba aquí el Nombre del establecimiento"
                >
                <span v-if="editError.storeName" class="errors">{{ editError.storeName }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="text_label">Departamento *</label>
                <select 
                  v-model="editForm.state" 
                  @change="getCities(editForm.state)" 
                  class="form-control"
                >
                  <option selected value="null">Seleccione el Departamento</option>
                  <option 
                    v-for="state in listStates" 
                    :key="state.id" 
                    :value="state.id"
                  >
                    {{ state.name }}
                  </option>
                </select>
                <span v-if="editError.state" class="errors">{{ editError.state }}</span>
              </div>
              <div class="form-group col-md-6">
                <label class="text_label">Ciudad *</label>
                <select 
                  v-model="editForm.city" 
                  class="form-control"
                >
                  <option disabled selected value="null">Seleccione la Ciudad</option>
                  <option 
                    v-for="city in listCities" 
                    :key="city.id" 
                    :value="city.id"
                  >
                    {{ city.name }}
                  </option>
                </select>
                <span v-if="editError.city" class="errors">{{ editError.city }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="text_label">Dirección *</label>
                <input 
                  v-model="editForm.address" 
                  type="text" 
                  class="form-control" 
                  placeholder="Escriba aquí la Dirección"
                >
                <span v-if="editError.address" class="errors">{{ editError.address }}</span>
              </div>
              <div class="form-group col-md-6">
                <label class="text_label">Email *</label>
                <input 
                  v-model="editForm.email" 
                  type="email" 
                  class="form-control" 
                  placeholder="Escriba aquí el Email"
                >
                <span v-if="editError.email" class="errors">{{ editError.email }}</span>
              </div>
            </div>
            <div class="form-row justify-content-center">
              <div class="form-group col-md-6">
                <label class="text_label">Número telefónico *</label>
                <input 
                  v-model="editForm.phone" 
                  type="number" 
                  class="form-control" 
                  placeholder="Escriba aquí el Número telefónico"
                >
                <span v-if="editError.phone" class="errors">{{ editError.phone }}</span>
              </div>
              <div class="form-group col-md-6">
                <label class="text_label">Distribuidor *</label>
                <select 
                  v-model="editForm.distributor" 
                  class="form-control"
                >
                  <option disabled selected value="null">Seleccione el Distribuidor</option>
                  <option 
                    v-for="dist in listDist" 
                    :key="dist.id" 
                    :value="dist.id"
                  >
                    {{ dist.name }}
                  </option>
                </select>
                <span v-if="editError.distributor" class="errors">{{ editError.distributor }}</span>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-secondary" 
              data-dismiss="modal"
              @click="closeModal(2)"
            >
              <strong>Cerrar</strong>
            </button>
            <button
              type="button" 
              class="btn btn-primary"
              @click="btnEdit()"
            >
              <span v-if="loading.update"><strong>Actualizando...</strong></span>
              <span v-else><strong>Actualizar</strong></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal asignar puntos -->
    <div
      class="modal fade"
      id="modalAssignPoints"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal_assign" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
              @click="closeModal(3)"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color:#616161; font-size:20px;">
                  <strong>Asignar puntaje</strong></label><br>
              </div>

              <div class="col-12">
                <div class="row" style="text-align: left">
                  <div class="col-12 col-md-12">
                    <div class="form-row">
                      <div class="form-group col-12 col-md-12">
                        <label class="text_label">Tipo de lubricante *</label>
                        <select 
                          v-model="formAssign.type_of_oil"
                          class="form-control"
                        >
                          <option disabled selected value="null">Seleccionar</option>
                          <option value="1">Mineral</option>
                          <option value="2">Semi Synthetic</option>
                          <option value="3">Full Synthetic</option>
                        </select>
                        <span v-if="errorsAssign.type_of_oil" class="errors">{{ errorsAssign.type_of_oil }}</span>
                      </div>
                      <div class="form-group col-12 col-md-12">
                        <label class="text_label">Cajas *</label>

                        <input 
                          v-model="formAssign.boxes" 
                          type="number" 
                          class="form-control" 
                          placeholder="Escriba aquí la cantidad de cajas"
                        >
                        <span v-if="errorsAssign.boxes" class="errors">{{ errorsAssign.boxes }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                  @click="closeModal(3)"
                >
                  <strong>Cancelar</strong>
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="assignPoints()"
                  type="button"
                  class="btn btn-info btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <strong>Guardando...</strong>
                  </template>
                  <template v-else><strong>Guardar</strong></template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      list: true,
      created: false,
      listDist: [],
      dist_id: null,
      point_of_sale_id: null,
      distributor_id: null,
      listPOS: [],
      formCreate: {
        nit: null,
        storeName: null,
        state: null,
        city: null,
        address: null,
        email: null,
        phone: null,
        distributor: null
      },
      errorsCreate: {
        nit: false,
        storeName: false,
        state: false,
        city: false,
        address: false,
        email: false,
        phone: false,
        distributor: false
      },
      editForm: {
        nit: null,
        storeName: null,
        state: null,
        city: null,
        address: null,
        email: null,
        phone: null,
        distributor: null
      },
      editError: {
        nit: false,
        storeName: false,
        state: false,
        city: false,
        address: false,
        email: false,
        phone: false,
        distributor: false
      },
      formAssign: {
        type_of_oil: null,
        boxes: null,
      },
      errorsAssign: {
        type_of_oil: false,
        boxes: false
      },
      loading: {
        history: false,
        create: false,
        update: false,
        changeDoc: false
      },
      listStates: [],
      listCities: [],
      showCities: true,
      disabled: true,
    };
  },
  methods: {
    changeView(opc){
      if(opc == 1){
        this.list = true;
        this.created = false;
        $(".list").addClass("selected");
        $(".created").removeClass("selected");
      } else {
        this.list = false;
        this.created = true;
        $(".created").addClass("selected");
        $(".list").removeClass("selected");
      }
    },
    getDistributor() {
      axios
      .get("superAdmin/all/distributors")
      .then(res => {
        if (res.data.cod == 0) {
          this.listDist = res.data.data;
        }
      })
      .catch(() => {});
    },
    getByDist(id){
      this.listPOS = [];
      this.loading.history = true;

      if(id != "null" && id != null){
        axios
        .post("superAdmin/get-pos/" + id)
        .then((res) => {
          if (res.data.cod == 0) {
            this.listPOS = res.data.data;
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          console.log(error);
        });
      }
    },
    getStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listStates = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    validFormCreate(){
      const requiredFields = {
        nit: "El Nit es requerido",
        storeName: "El Nombre del establecimiento es requerido",
        state: "El Departamento es requerido",
        city: "La Ciudad es requerida",
        address: "La Dirección es requerida",
        email: "El Email es requerido",
        phone: "El Número telefónico es requerido",
        distributor: "El Distribuidor es requerido"
      };
      for (const [field, errorMessage] of Object.entries(requiredFields)) {
        if (!this.formCreate[field]) {
          this.errorsCreate[field] = errorMessage;
          return false;
        }
      }
      return true;
    },
    createPOS(){
      if(this.validFormCreate()){
        this.loading.create = true;
        axios
        .post('superAdmin/create-point-of-sale', this.formCreate)
        .then((res) => {
          if(res.data.cod == 0){
            this.loading.create = false;
            this.$swal({
              icon: "success",
              title: "Excelente",
              text: res.data.message,
              confirmButtonColor: "#dc3545"
            });
            this.clearForm(1);
          } else {
            this.loading.create = false;
            this.$swal({
              icon: "warning",
              title: "Oops...",
              text: res.data.message,
              confirmButtonColor: "#dc3545"
            });
          }
        })
        .catch((err) => {
          this.loading.create = false;
          console.log(err);
        });
      }
    },
    editPOS(item){
      const element = this.listPOS.find(element => element.id === item.id);
      this.getCities(element.state_id);
      if(element){
        this.editForm = {
          id: element.id,
          nit: element.document_number,
          storeName: element.name,
          state: element.state_id,
          city: element.city_id,
          address: element.address,
          email: element.email,
          phone: element.phone,
          distributor: element.distributor_id
        };
      }
      $("#editModal").modal("show");
    },
    validFormEdit(){
      const requiredFields = {
        nit: "El Nit es requerido",
        storeName: "El Nombre del establecimiento es requerido",
        state: "El Departamento es requerido",
        city: "La Ciudad es requerida",
        address: "La Dirección es requerida",
        email: "El Email es requerido",
        phone: "El Número telefónico es requerido",
        distributor: "El Distribuidor es requerido"
      };
      for (const [field, errorMessage] of Object.entries(requiredFields)) {
        if (!this.editForm[field]) {
          this.editError[field] = errorMessage;
          return false;
        }
      }
      return true;
    },
    btnEdit(){
      if(this.validFormEdit()){
        this.loading.update = true;
        axios
        .post('superAdmin/edit-points-of-sale', this.editForm)
        .then((res) => {
          if(res.data.cod == 0){
            this.loading.update = false;
            $("#editModal").modal("hide");
            this.clearForm(2);
            this.$swal({
              icon: "success",
              title: "Excelente",
              text: res.data.message,
              confirmButtonColor: "#dc3545"
            });
            this.getByDist(this.dist_id);
          } else {
            this.loading.update = false;
            this.$swal({
              icon: "warning",
              title: "Oops...",
              text: res.data.message,
              confirmButtonColor: "#dc3545"
            });
          }
        })
        .catch((err) => {
          this.loading.update = false;
          console.log(err);
        });
      }
    },
    assignModal(item) {
      this.point_of_sale_id = item.id;
      this.distributor_id = item.distributor_id;
      $("#modalAssignPoints").modal("show");
    },
    validFormAssign(){
      const requiredFields = {
        type_of_oil: "El Tipo de lubricante es requerido",
        boxes: "La cantidad de Cajas es requerida"
      };
      for (const [field, errorMessage] of Object.entries(requiredFields)) {
        if (!this.formAssign[field]) {
          this.errorsAssign[field] = errorMessage;
          return false;
        }
      }
      return true;
    },
    assignPoints() {
      const data = {
        point_of_sale_id: this.point_of_sale_id,
        distributor_id: this.distributor_id
      }
      Object.assign(this.formAssign, data);
      if(this.validFormAssign()){
        this.loading.changeDoc = true;
        axios
        .post("superAdmin/assign-points", this.formAssign)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
          }
          this.loading.changeDoc = false;
          $("#modalAssignPoints").modal("hide");
          this.getByDist(this.dist_id);
          this.clearForm(3);
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Error",
            text: error.response.data.message
          });
        });
      }
    },
    deletePOS(item){
      this.$swal({
        icon: "question",
        title: "¿Seguro que deseas eliminar este punto de venta?",
        html: "<b>Aviso importante: </b>Esta acción es irreversible.",
        confirmButtonText: "Sí, eliminar",
        confirmButtonColor: "#dc3545",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#1da5df"
      }).then((res) => {
        if(res.isConfirmed){
          axios
          .post('superAdmin/delete-point-of-sale/' + item.id)
          .then((res) => {
            if(res.data.cod == 0){
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: res.data.message,
                confirmButtonColor: "#dc3545"
              });
              this.getByDist(this.dist_id);
            } else {
              this.$swal({
                icon: "warning",
                title: "Oops...",
                text: res.data.message,
                confirmButtonColor: "#dc3545"
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }
      });
    },
    clearErrorCreateEdit(field, value, type) {
      if(type == 1){
        const valueStr = String(value);
        if (valueStr.trim() || field === 'state' || field === 'city') {
          this.$set(this.errorsCreate, field, '');
        }
      } else {
        this.$set(this.editError, field, '');
      }
    },
    clearErrorAssign(field) {
      this.$set(this.errorsAssign, field, '');
    },
    closeModal(opc){
      this.clearForm(opc);
    },
    clearForm(opc){
      if(opc == 1){
        this.formCreate = {
          nit: null,
          storeName: null,
          state: null,
          city: null,
          address: null,
          email: null,
          phone: null,
          distributor: null
        },
        setTimeout(() => {
          this.errorsCreate.nit = false;
          this.errorsCreate.storeName = false;
          this.errorsCreate.state = false;
          this.errorsCreate.city = false;
          this.errorsCreate.address = false;
          this.errorsCreate.email = false;
          this.errorsCreate.phone = false;
          this.errorsCreate.distributor = false;
        }, 100);
      } 
      else if(opc == 2){
        this.editForm = {
          nit: null,
          storeName: null,
          state: null,
          city: null,
          address: null,
          email: null,
          phone: null,
          distributor: null
        },
        setTimeout(() => {
          this.editError.nit = false;
          this.editError.storeName = false;
          this.editError.state = false;
          this.editError.city = false;
          this.editError.address = false;
          this.editError.email = false;
          this.editError.phone = false;
          this.editError.distributor = false;
        }, 100);
      } else {
        this.formAssign = {
          type_of_oil: null,
          boxes: null
        },
        setTimeout(() => {
          this.errorsAssign.type_of_oil = false;
          this.errorsAssign.boxes = false;
        }, 100);
      }
    },
  },
  watch: {
    // Creación de Punto de Venta
    'formCreate.nit': function(newValue) {
      this.clearErrorCreateEdit('nit', newValue, 1);
    },
    'formCreate.storeName': function(newValue) {
      this.clearErrorCreateEdit('storeName', newValue, 1);
    },
    'formCreate.state': function(newValue) {
      this.clearErrorCreateEdit('state', newValue, 1);
      this.formCreate.city = '';
    },
    'formCreate.city': function(newValue) {
      this.clearErrorCreateEdit('city', newValue, 1);
    },
    'formCreate.address': function(newValue) {
      this.clearErrorCreateEdit('address', newValue, 1);
    },
    'formCreate.email': function(newValue) {
      this.clearErrorCreateEdit('email', newValue, 1);
    },
    'formCreate.phone': function(newValue) {
      this.clearErrorCreateEdit('phone', newValue, 1);
    },
    'formCreate.distributor': function(newValue) {
      this.clearErrorCreateEdit('distributor', newValue, 1);
    },

    // Actualización de datos
    'editForm.nit': function(newValue) {
      this.clearErrorCreateEdit('nit', newValue, 2);
    },
    'editForm.storeName': function(newValue) {
      this.clearErrorCreateEdit('storeName', newValue, 2);
    },
    'editForm.state': function(newValue) {
      this.clearErrorCreateEdit('state', newValue, 2);
      this.editForm.city = '';
    },
    'editForm.city': function(newValue) {
      this.clearErrorCreateEdit('city', newValue, 2);
    },
    'editForm.address': function(newValue) {
      this.clearErrorCreateEdit('address', newValue, 2);
    },
    'editForm.email': function(newValue) {
      this.clearErrorCreateEdit('email', newValue, 2);
    },
    'editForm.phone': function(newValue) {
      this.clearErrorCreateEdit('phone', newValue, 2);
    },
    'editForm.distributor': function(newValue) {
      this.clearErrorCreateEdit('distributor', newValue, 1);
    },

    // Asignación de puntos
    'formAssign.type_of_oil': function(newValue) {
      this.clearErrorAssign('type_of_oil', newValue);
    },
    'formAssign.boxes': function(newValue) {
      if(this.formAssign.boxes > 10){
        this.$swal({
          icon: "warning",
          title: "Advertencia",
          text: "La cantidad máxima permitida es 10",
          confirmButtonColor: "#dc3545"
        });
        this.formAssign.boxes = null;
      }
      this.clearErrorAssign('boxes', newValue);
    },
  },
  mounted() {
    this.getDistributor();
    this.getStates();
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 8% 1%;
  overflow: hidden;
}
.modal-title {
  color: black;
  font-weight: bold;
}
label {
  color: black;
  margin-right: 4px;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
h5 {
  margin-bottom: 10px !important;
}
.errors{
  position: relative;
  top: 10px;
  color: #dc3545;
}
.info > .title_info, .info > .desc_info{
  color: black;
}
.info{
  text-align: start;
  padding: 10px 0px;
}
.title_info{
  padding: 0px 0px 5px 0px;
  font-family: "GothamBoldItalic", sans-serif;
}
.desc_info > span > strong{
  color: #dc3545;
}
.nav-link{
  cursor: pointer;
  color: #1da5df !important;
}
.section_list, .section_create{
  padding: 40px 5px;
}
.selected, .selected:hover{
  border: 1px solid #dc3545;
}
.action_1{
  color: #1da5df;
  cursor: pointer;
}
.action_2{
  color: #dc3545;
  cursor: pointer;
}
.text_label{
  color: black;
}
.errors{
  position: relative;
  top: 10px;
  color: #dc3545;
}
.btn-danger{
  padding: 4px 50px;
}
.section_btn{
  margin-top: 20px;
}
.modal-dialog{
  min-width: 750px !important;
}
.modal_assign{
  min-width: 350px !important;
}
.close{
  color: black;
}
.modal-title{
  color: black;
  font-family: "GothamBoldItalic", sans-serif;
}
.btn-primary{
  background-color: #1da5df;
}
.btn-secondary{
  background-color: #dc3545;
  margin: 0px auto 0px 0px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@font-face {
  font-family: "GothamLight";
  src: url('../../../../assets/font/GothamLight.ttf');
}
@font-face {
  font-family: "GothamBookItalic";
  src: url('../../../../assets/font/GothamBookItalic.ttf');
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url('../../../../assets/font/GothamBoldItalic.ttf');
}
</style>
